<template>
  <v-container v-if="interviewStarted" fluid>
    <v-stepper v-model="step">
      <v-stepper-header class="v-toolbar v-toolbar--card theme--dark primary">
        <v-stepper-step :complete="step > 1" step="1">{{ 'app.interview.general_information' | trans }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2">{{
            'app.interview.diseases_and_symptoms' | trans
          }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3">{{
            'app.interview.additional_information' | trans
          }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4">{{
            'app.interview.preferences' | trans
          }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="5">{{ 'app.interview.custom_questions' | trans }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <general-information-form ref="generalInformationForm"></general-information-form>
          <v-divider></v-divider>
          <v-layout align-center justify-end row fill-height>
            <v-btn color="primary" @click="saveAndClose(1)" :disabled="loading" :loading="loading">{{
                'app.interview.save_and_close' | trans
              }}
            </v-btn>
            <v-btn color="primary" @click="next(1)" :disabled="loading" :loading="loading">{{
                'app.next' | trans
              }}
            </v-btn>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="2">
          <diseases-and-symptoms-form ref="diseasesAndSymptomsForm"></diseases-and-symptoms-form>
          <v-divider></v-divider>
          <v-layout align-center justify-end row fill-height>
            <v-btn @click="previous(2)" :disabled="loading" :loading="loading">{{ 'app.previous' | trans }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveAndClose(2)" :disabled="loading" :loading="loading">{{
                'app.interview.save_and_close' | trans
              }}
            </v-btn>
            <v-btn color="primary" @click="next(2)" :disabled="loading" :loading="loading">{{
                'app.next' | trans
              }}
            </v-btn>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="3">
          <additional-info-form ref="additionalInfoForm"></additional-info-form>
          <v-divider></v-divider>
          <v-layout align-center justify-end row fill-height>
            <v-btn @click="previous(3)" :disabled="loading" :loading="loading">{{ 'app.previous' | trans }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveAndClose(3)" :disabled="loading" :loading="loading">{{
                'app.interview.save_and_close' | trans
              }}
            </v-btn>
            <v-btn color="primary" @click="next(3)" :disabled="loading" :loading="loading">{{
                'app.next' | trans
              }}
            </v-btn>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="4">
          <preferences-form ref="preferencesForm" @saved="otherAllergySaved"></preferences-form>
          <v-divider></v-divider>
          <v-layout align-center justify-end row fill-height>
            <v-btn @click="previous(4)" :disabled="loading" :loading="loading">{{ 'app.previous' | trans }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveAndClose(4)" :disabled="loading" :loading="loading">{{
                'app.interview.save_and_close' | trans
              }}
            </v-btn>
            <v-btn color="primary" @click="next(4)" :disabled="loading" :loading="loading">{{
                'app.next' | trans
              }}
            </v-btn>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="5">
          <custom-questions-form ref="customQuestionsForm"></custom-questions-form>
          <v-divider></v-divider>
          <v-layout align-center justify-end row fill-height>
            <v-btn @click="previous(5)" :disabled="loading" :loading="loading">{{ 'app.previous' | trans }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save()" :disabled="loading" :loading="loading">{{
                'app.save' | trans
              }}
            </v-btn>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
  <v-container v-else fluid>
    <v-layout row align-center justify-center mb-10 v-if="hasPermission('surveys_create')">
      <v-alert :value="true" type="info">
        <p v-html="trans('app.surveys.introducing', {url: '/templates/surveys'})"></p>
      </v-alert>
    </v-layout>
    <h4 class="text-center" v-if="hasPermission('surveys_create')">{{ `app.surveys.add_own_questions_to_interview`|trans }}:</h4>
    <v-layout row align-center justify-center>
      <v-flex xs4>
        <v-autocomplete
            v-model="selectedSurvey"
            :items="surveys"
            :label="'app.surveys.survey' | trans"
            item-text="name"
            item-value="id"
            return-object
            hide-details
            v-if="hasPermission('surveys_create')"
        >
          <template v-slot:selection="data">
            {{ data.item.name }}
            <template v-if="data.item.shared">
              <v-tooltip right>
                <template #activator="{ on }">
                  <v-icon v-on="on" small color="success">share</v-icon>
                </template>
                <span>{{ trans('app.sharing.shared_by', {name: data.item.owned_by}) }}</span>
              </v-tooltip>
            </template>
          </template>
          <template v-slot:item="data">
            <template>
              {{ data.item.name }}
              <template v-if="data.item.shared">
                <v-tooltip right>
                  <template #activator="{ on }">
                    <v-icon v-on="on" small color="success">share</v-icon>
                  </template>
                  <span>{{ trans('app.sharing.shared_by', {name: data.item.owned_by}) }}</span>
                </v-tooltip>
              </template>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row align-center justify-center>
      <v-flex xs4 class="text-xs-center">
        <permission-button color="primary" @click="startInterview()"
                           :permission="`patient_interview_manage`"
                           :tooltip="{top: true, bottom: false, attach: false}"
        >
          {{ `app.interview.interview` | trans }}
        </permission-button>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  data() {
    return {
      selectedSurvey: null,
      interviewStarted: false,
      step: 1,
      loading: false,
    }
  },
  async mounted() {
    try {
      await this.fetchSurveys();
    } catch (error) {
      this.sentryCaptureException(error);
    }
  },
  computed: {
    ...mapGetters(['patient', 'interview', 'hasPermission', 'surveys']),
  },
  methods: {
    ...mapActions(['fetchSurveys', 'fetchLikeables']),
    startInterview() {
      this.interviewStarted = true;
    },
    async saveAndClose(currentStep) {
      this.loading = true;
      let success = true;
      if (currentStep === 1) {
        success = await this.$refs.generalInformationForm.save();
      }
      if (currentStep === 2) {
        success = await this.$refs.diseasesAndSymptomsForm.save();
      }
      if (currentStep === 3) {
        success = await this.$refs.additionalInfoForm.save();
      }
      if (currentStep === 4) {
        success = await this.$refs.preferencesForm.save();
      }
      if (success) {
        this.$emit('saved', {id: this.interview.id});
      }
      this.loading = false;
    },
    async next(currentStep) {
      this.loading = true;
      let success = true;
      if (currentStep === 1) {
        success = await this.$refs.generalInformationForm.save();
      }
      if (currentStep === 2) {
        success = await this.$refs.diseasesAndSymptomsForm.save();
      }
      if (currentStep === 3) {
        success = await this.$refs.additionalInfoForm.save();
      }
      if (currentStep === 4) {
        success = await this.$refs.preferencesForm.save();
      }

      if (success) {
        this.step = currentStep + 1;
        if (currentStep === 4 && this.selectedSurvey) {
          await this.$nextTick();
          this.$refs.customQuestionsForm.setSurvey(this.selectedSurvey);
        }
      }
      this.loading = false;
    },
    async previous(currentStep) {
      this.loading = true;
      let success = true;
      if (currentStep === 2) {
        success = await this.$refs.diseasesAndSymptomsForm.save();
      }
      if (currentStep === 3) {
        success = await this.$refs.additionalInfoForm.save();
      }
      if (currentStep === 5) {
        success = await this.$refs.customQuestionsForm.save();
      }
      if (success) {
        this.step = currentStep - 1;
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      let success = await this.$refs.customQuestionsForm.save();
      if (success) {
        this.$emit('saved', {id: this.interview.id});
      }
      this.loading = false;
    },
    async otherAllergySaved() {
      await this.fetchLikeables({patientId: this.patient.id});
    },
  }
}
</script>
